export const environment = {
  // DEV
  // http://safrasao122156.protheus.cloudtotvs.com.br:4050/rest/recorrencia
  // HOMOLOG
  // http://safrasao139664.protheus.cloudtotvs.com.br:4050/rest/recorrencia
  // PROD
  // https://safrasao122154.protheus.cloudtotvs.com.br:4050/rest/recorrencia
  production: false,
  urlApi:
    'http://safrasao139664.protheus.cloudtotvs.com.br:4050/rest/recorrencia',
  oauth: {
    tokenUrl:
      'http://safrasao139664.protheus.cloudtotvs.com.br:4050/rest/api/oauth2/v1/token',
    username: 'portal',
    password: 'totvs@2025',
    grantType: 'password',
  },
  cryptKey: 'mailRecorrencia.tlpp',
};
